import React from "react";
import { Select } from "antd";

const { Option } = Select;

const CustomDynamicSelect = ({
  allowClear = false,
  showSearch=false,
  mode,
  width,
  height,
  border,
  bgColor,
  textColor,
  borderRadius,
  placeholderColor,
  lineHeight,
  value,
  options,
  boxShadow,
  disabled,
   label="name",
   isSensor=false,
   isCourier=false,
  ...props
 
}) => {
  

  const customStyle = {
    minHeight: height || "36px",
    width: width || "100%",
    border: border || "1px solid #d9d9d9",
    backgroundColor: bgColor || "#fff",
    color: textColor || "#000",
    borderRadius: borderRadius || "8px",
    lineHeight: lineHeight || "normal",
    boxShadow: boxShadow || "none",
  };

  const placeholderStyle = {
    "::placeholder": {
      color: placeholderColor || "#5e5e5e",
    },
  };

  return (
    <Select
    showSearch={showSearch}
        allowClear={allowClear}
        mode={mode}
        value={value}
        placeholder="Select"
        style={{ ...customStyle }}
        disabled={disabled}
        {...props}
    >
      {options && options.map((option, index) => (
        <Option key={index} disabled={option?.disabled} value={isSensor ? option.sensor_id :  (isCourier ? option?.courier_id : option.id)}>
          {option[label]}
        </Option>
      ))}
    </Select>
  );
};

export default CustomDynamicSelect;